export default __webpack_public_path__ + "static/media/masthead-animation.b97a892f.gif";